import {reqMenuList} from '../api'
export default {
    namespaced:true,
    actions: {
        // 得到 左侧菜单列表
        async getMenuList({commit,state}) {
            const result = await reqMenuList();
            if (result.code === 1) {
                const menuList = result.data;
                // console.log(menuList);
                commit("RECEIVE_MENU_LIST",{menuList});
            }
            else if(result.code == -1)
            {
                this.$router.push("/login");
            }
        },
    },
    mutations: {
        RECEIVE_MENU_LIST: (state,{menuList}) => {
            state.menuList = menuList;
        },
    },
    state: {
        menuList: [], // 左侧菜单数据列表

    },
    getters: {

    }
}



// WEBPACK FOOTER //
// ./src/store/menu.js